module.exports = "#timelinetoolbar{border-radius:40px}.vis-timeline.vis-bottom{visibility:visible !important}\n"